import { Navigate } from "react-router-dom";
import { useBeta } from "../context/BetaContext";

/**
 * Iter-158.0 — Route wrapper for the protected /beta area.
 *
 * Renders children only when the current user has
 * `beta_flags.multi_dept === true` (as reported by GET /api/beta/me).
 * While loading we return null (avoids a flash of beta UI or an early
 * redirect during bootstrap). Non-beta users are silently redirected
 * to "/" — matching the user's requirement that they see no trace of
 * the beta area whatsoever.
 */
export default function BetaGate({ children }) {
    const { hasBetaAccess, loading } = useBeta();
    if (loading) return null;
    if (!hasBetaAccess) return <Navigate to="/" replace />;
    return children;
}
